import {useState} from "react";
import {useForm, Controller, useFieldArray} from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import _ from "lodash";
import {
	Button,
	Loading
} from "~/components";
import {
	GroupRadioField,
	InputField,
	SelectServiceAll
} from "~/components/Forms";
import {apiError, handleRequest} from "~/utils";
import {serviceApi} from "~/api";

function ToDoFormAddMail({onHandleSubmit}) {

	const [loading, setLoading] = useState(false);

	const [domains, setDomains] = useState([]);

	const [domainsHost, setDomainsHost] = useState([]);

	const initialValues = {
		serviceId: undefined,
		domain: undefined,
		mails: [{name: ''}],
	}

	const validationSchema = Yup.object().shape({
		serviceId: Yup.string().required('Bạn chưa chọn dịch vụ'),
		domain: Yup.string().required('Bạn chưa chọn tên miền'),
		mails: Yup.array().of(
			Yup.object().shape({
				name: Yup.string().required('Bạn chưa điền tên mail')
			})
		).min(1, 'Cần ít nhất 1 tên mail')
	})

	const { control, handleSubmit, formState: { isSubmitting, errors } } = useForm({
		defaultValues: initialValues,
		resolver: yupResolver(validationSchema)
	});

	const { fields, append, remove } = useFieldArray({ control, name: 'mails' });

	const handleServiceChange = async (value) => {
		setLoading(true);
		let [error, response] = await handleRequest(serviceApi.domains(value));
		let message = apiError(`Load thông tin hợp đồng thất bài`, error, response);
		if(!message) {
			setDomains(response.data.main)
			setDomainsHost(response.data.host)
		}
		setLoading(false);
	}

	const RenderDomain = () => {
		if(!_.isEmpty(domains)) {
			let domainOptions = [...domainsHost.map((domain) => {
				return {
					value: domain,
					label: domain
				};
			})];
			return (
				<>
					<br />
					<p className="heading">Chọn tên miền để tạo mail</p>
					<Controller control={control} name="domain" render={({field}) => (
						<GroupRadioField options={domainOptions} errors={errors} {...field}/>
					)}/>
					<p className="heading">Danh sách tên mail</p>
					{fields.map((item, index) => (
						<div key={item.id} className="d-flex gap-1" style={{marginBottom: '8px', alignItems: 'flex-start'}}>
							<div style={{flex: 1}}>
								<Controller control={control} name={`mails.${index}.name`} render={({field}) => (
									<InputField
										placeholder="Nhập tên mail"
										errors={errors?.mails?.[index]}
										{...field}
									/>
								)}/>
							</div>
							{fields.length > 1 && (
								<Button red background type="button" className={'mt-0'} onClick={() => remove(index)} style={{marginTop: '28px'}}>Xóa</Button>
							)}
						</div>
					))}
					<Button green background type="button" onClick={() => append({name: ''})} style={{marginBottom: '8px'}}>+ Thêm mail</Button>
				</>
			)
		}
	}

	const onSubmit = async (data) => {
		await onHandleSubmit(data);
	}

	return (
		<form className="form" onSubmit={handleSubmit(onSubmit)}>
			{isSubmitting && <Loading/>}
			<Controller control={control} name="serviceId" render={({ field }) => (
				<SelectServiceAll service={"host"} label="Host bạn muốn tạo mail" placeholder={'Điền tên miền hiện tại của dịch vụ host'} options={[]} errors={errors} {...field} onChange={(value, event) => {
					handleServiceChange(value).then();
					field.onChange(value, event);
				}}/>
			)}/>
			{loading && <div className="d-flex justify-content" style={{width:'100%'}}><Loading noFixed spin /></div>}
			{!loading && <RenderDomain />}
			<hr />
			<div className="form-group d-flex justify-content-end modal-bottom">
				<Button primary type="submit">Tạo yêu cầu</Button>
			</div>
		</form>
	)
}

export default ToDoFormAddMail;